
export const setTitleHeaderMansioni = (dataset) => `Mansioni svolte dalla ${dataset.serviziPrestati.map(el => el.nomeservizio)} `;
